module.exports = __webpack_public_path__ + "img/analysis__partthree_reply_blue.909b9df1.svg";